import type { IconAsset } from '../Icon.types';

export const stava: IconAsset = {
  regular: {
    l: {
      code: (
        <g>
          <path
            d='M11.287 2.00098L5 14.13H8.70599L11.292 9.30795L13.8539 14.13H17.532L11.287 2.00098ZM17.527 14.13L15.7 17.794L13.847 14.131H11.041L15.702 23.2729L20.334 14.131L17.527 14.13Z'
            fill='currentColor'
          />
        </g>
      ),
    },
    m: {
      code: (
        <g>
          <path
            d='M11.287 2.00098L5 14.13H8.70599L11.292 9.30795L13.8539 14.13H17.532L11.287 2.00098ZM17.527 14.13L15.7 17.794L13.847 14.131H11.041L15.702 23.2729L20.334 14.131L17.527 14.13Z'
            fill='currentColor'
          />
        </g>
      ),
    },
    s: {
      code: (
        <g>
          <path
            d='M11.287 2.00098L5 14.13H8.70599L11.292 9.30795L13.8539 14.13H17.532L11.287 2.00098ZM17.527 14.13L15.7 17.794L13.847 14.131H11.041L15.702 23.2729L20.334 14.131L17.527 14.13Z'
            fill='currentColor'
          />
        </g>
      ),
    },
  },
};
